import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({ inline = false, size = "md" }) => {
  const spinner = (
      <div className={`gradient-spinner gradient-spinner-${size}`}>
        <div className="gradient-spinner-ring" />
        <div className="gradient-spinner-ring gradient-spinner-ring-inner" />
        <div className="gradient-spinner-core" />
      </div>
  );

  if (inline) {
    return spinner;
  }

  return <div className="fullscreen-loader">{spinner}</div>;
};

export default LoadingSpinner;